import {ReactNode, ReactNodeArray} from 'react'
import {NavigationBar} from '../../components/navigation/navigation-bar'

import {FixedPageSizeContainer} from './container.styled'
import {NavigationWrapper} from './navigation-wrapper.styled'

interface Props {
    children: ReactNode | ReactNodeArray
}
export function FixedPageTemplate({children}: Props): JSX.Element {
    return (
        <FixedPageSizeContainer>
            <NavigationWrapper>
                <NavigationBar />
            </NavigationWrapper>
            {children}
        </FixedPageSizeContainer>
    )
}
